import { useCallback, useEffect } from "react";
import { useActions } from "../useActions";
import { useSelector } from "react-redux";
import { RootState } from "../../state/store";
import { useTypedSelector } from "../useTypedSelector";

function usePushbackOrderDetails(loanNumber: string) {

    const { getPushbackOrderDetailsData } = useActions();
    const accessToken = useSelector((state: RootState) => state.appSlice.accessToken);
    const configId = useSelector((state: RootState) => state.appSlice.configId);
    const { data, error, loading } = useTypedSelector((state) => state.pushbackOrderDetails);

    const isLoanNumberValid = loanNumber && loanNumber.trim() !== "";

    const fetchData = useCallback(() => {
        if (isLoanNumberValid && configId) {
            getPushbackOrderDetailsData(configId, accessToken, loanNumber); // Access token not required since proxy will generate if needed locally
        }
    }, [getPushbackOrderDetailsData, accessToken, loanNumber, isLoanNumberValid, configId]);

    useEffect(() => {
        if (loanNumber) {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loanNumber]);

    if (!isLoanNumberValid) {
        return { data: null, error: "", loading: false };
    }


    return { data, loading, error };
}

export { usePushbackOrderDetails };